<div class="settings-card">
    <div class="settings-card__header">
        <img src="/assets/images/Group 24.svg" alt="" />
        <div class="settings-card__header-headline">
            <h2>Recenzii</h2>
        </div>
    </div>
</div>
<div class="requests-page">
    <div class="content-box">
        <div class="row">
            <div class="col-sm-12">
                <div class="section">
                    <div class="section-top">
                        <h3 class="section-title">Recenzii</h3>
                        <div class="row">
                            <div class="col">
                                <button type="button" class="btn btn-sm btn-info pull-right ms-1"
                                    (click)="refreshPage()">
                                    <i class="fa-solid fa-arrows-rotate"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-container request-filter p-2" *ngIf="showCard">
                        <form [formGroup]="searchParamsForm" (ngSubmit)="applyFilters()">
                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Tip acțiune</mat-label>
                                        <mat-select formControlName="action_type">
                                            <mat-option *ngFor="let option of tipActiuneOptions" [value]="option.id">
                                                {{option.name}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Notă</mat-label>
                                        <mat-select formControlName="nota">
                                            <mat-option *ngFor="let option of notaOptions" [value]="option.id">
                                                {{option.name}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Active</mat-label>
                                        <mat-select formControlName="status">
                                            <mat-option *ngFor="let option of statusOptions" [value]="option.id">
                                                {{option.name}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Cetățean</mat-label>
                                        <input type="text" matInput formControlName="cetatean_name"
                                            [matAutocomplete]="auto" />
                                        <mat-icon matSuffix class="opacity-50">search</mat-icon>
                                        <mat-autocomplete #auto="matAutocomplete">
                                            <mat-option *ngFor="let citizen of searchedCitizens" [value]="citizen.name"
                                                (onSelectionChange)="onCitizenSelected(citizen)">
                                                {{ citizen.name }}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Spam</mat-label>
                                        <mat-select formControlName="status_spam">
                                            <mat-option *ngFor="let option of spamOptions" [value]="option.id">
                                                {{option.name}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col d-flex justify-content-start">
                                    <button (click)="toggleCard()" type="button"
                                        class="btn btn-sm btn-warning closeBtn">
                                        Închide
                                    </button>
                                </div>
                                <div class="col buttons-submit">
                                    <button (click)="resetForm()" type="button" class="btn btn-sm btn-secondary">
                                        Resetează
                                    </button>
                                    <button type="submit" class="btn btn-sm btn-primary ms-2">
                                        Aplică
                                    </button>
                                </div>
                            </div>
                        </form>
                        <div class="section-spinner position-absolute" *ngIf="isFilterLoading">
                            <div class="spinner position-absolute top-50 start-50 translate-middle">
                                <mat-spinner></mat-spinner>
                                <h3 class="mt-2">
                                    {{ helper.dialogConfig.generalMessages.pleaseWait }}
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div class="row d-flex p-2">
                        <div class="col d-flex justify-content-start">
                            <button class="action-button" (click)="toggleCard()" [class.active]="showCard">
                                <img src="assets/images/icons8-filter-edit-50.png" alt="" />
                                <span>Filtre</span>
                            </button>
                        </div>
                        <div class="col d-flex justify-content-end">
                            <button type="button" class="btn btn-light action-button" [popover]="popTemplate"
                                [adaptivePosition]="true" container="body" boundariesElement="viewport"
                                placement="left">
                                <img src="assets/icons/calendar-icon.svg" alt="Calendar" />
                                <span>{{ selectedStartDate | date : "dd.MM.yyyy" }} - {{ selectedEndDate | date :
                                    "dd.MM.yyyy"
                                    }}
                                </span>
                            </button>

                            <!-- Popover Template below-->
                            <ng-template #popTemplate>
                                <div class="popover">
                                    <div class="row">
                                        <div class="col d-flex justify-content-between">
                                            <h2>Selectați intervalul</h2>
                                            <button style="height: 40px; width: 100px" class="btn btn-light close-btn"
                                                (click)="closePopover()">
                                                <img src="assets/icons/close.svg" alt="Închide"
                                                    style="height: 20px; width: 20px" />
                                                <span class="close-text">ÎNCHIDE</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <h3>Filtrare după</h3>
                                            <select [(ngModel)]="dateFilterOption">
                                                <option *ngFor="let value of dateFilteringOptions" [value]="value">
                                                    {{ value }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mt-2 mb-2">
                                        <div class="col d-flex justify-content-between responsive-filters">
                                            <button type="button" class="action-button" [class.selected]="
                          selectedFilteringButton === 'last_0_days'
                        " (click)="setLastXDays(0)">
                                                <span>AZI</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                          selectedFilteringButton === 'last_7_days'
                        " (click)="setLastXDays(7)">
                                                <span>7 ZILE</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                          selectedFilteringButton === 'last_30_days'
                        " (click)="setLastXDays(30)">
                                                <span>30 ZILE</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                          selectedFilteringButton === 'current_year'
                        " (click)="setYear(0)">
                                                <span>AN CURENT</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                          selectedFilteringButton === 'next_year'
                        " (click)="setYear(1)">
                                                <span>AN ANTERIOR</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="datepicker-container">
                                        <div class="col">
                                            <div class="datepicker-header">
                                                <div class="text">DE LA:</div>
                                                <div class="date">
                                                    {{ selectedStartDate | date : "mediumDate" }}
                                                </div>
                                            </div>
                                            <mat-card>
                                                <mat-calendar #startCalendar [(selected)]="selectedStartDate"
                                                    [maxDate]="today" [maxDate]="selectedEndDate"
                                                    (selectedChange)="rerenderDT()"></mat-calendar>
                                            </mat-card>
                                        </div>
                                        <div class="col">
                                            <div class="datepicker-header">
                                                <div class="text">PÂNĂ LA:</div>
                                                <div class="date">
                                                    {{ selectedEndDate | date : "mediumDate" }}
                                                </div>
                                            </div>
                                            <mat-card>
                                                <mat-calendar #endCalendar [(selected)]="selectedEndDate"
                                                    [maxDate]="today" (selectedChange)="rerenderDT()"></mat-calendar>
                                            </mat-card>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </div>

                    <div class="p-3 row">
                        <div *ngFor="let card of recenziiSectiuni" class="col-md-border col-xl-3 col-sm-6 d-flex flex-column justify-content-center align-items-center text-center">
                            <div class="note-text mb-2">Medie note:</div>
                            <div class="pie animate" [ngStyle]="{'--p': getMedie(card.medie), '--c': card['label-bg']}">{{ card.medie }}</div>
                            <div class="d-flex flex-column gap-1 mt-2">
                                <span class="label-text">{{ card.label }}</span>
                                <!-- <br> -->
                                <span class="recenzii-text">{{card.recenzii}} recenzii</span>
                            </div>
                        </div>
                    </div>

                    <div class="table-container">
                        <table id="datatable" class="row-border hover custom-dt w-100" datatable [dtOptions]="dtOptions"
                            [dtTrigger]="dtTrigger"></table>
                    </div>
                    <div class="section-spinner position-absolute" *ngIf="isLoading">
                        <div class="spinner position-absolute top-50 start-50 translate-middle">
                            <mat-spinner></mat-spinner>
                            <h3 class="mt-2">
                                {{ helper.dialogConfig.generalMessages.pleaseWait }}
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>